module.exports = __webpack_public_path__ + "media/images/icon_list/border-b0eef31f6064ab70cb15641b572df6ed.svg";